import React, { useState, useEffect, useRef, useContext } from "react";

import * as Yup from "yup";
import { Formik, FieldArray, Form, Field } from "formik";
import { toast } from "react-toastify";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import CircularProgress from "@material-ui/core/CircularProgress";
import Compressor from "compressorjs";

import { i18n } from "../../translate/i18n";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import {
  Checkbox,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import {
  AccessTime,
  AddCircle,
  Delete,
  Image,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Message,
  MicNone,
  Videocam,
  InsertDriveFile,
} from "@mui/icons-material";
import { capitalize } from "../../utils/capitalize";
import { Box, Chip } from "@material-ui/core";
import { AuthContext } from "../../context/Auth/AuthContext";
import MessageVariablesPicker from "../MessageVariablesPicker";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
  },

  extraAttr: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  btnWrapper: {
    position: "relative",
  },

  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

const FlowBuilderSingleBlockModal = ({
  open,
  onSave,
  onUpdate,
  data,
  close,
}) => {
  const classes = useStyles();
  const isMounted = useRef(true);

  const [activeModal, setActiveModal] = useState(false);

  const [rule, setRule] = useState();

  const [medias, setMedias] = useState([]);

  const [textDig, setTextDig] = useState();

  const [elements, setElements] = useState([]);

  const [elementsSeq, setElementsSeq] = useState([]);

  const [elementsSeqEdit, setElementsSeqEdit] = useState([]);

  const [elementsEdit, setElementsEdit] = useState([]);

  const [numberMessages, setNumberMessages] = useState(0);

  const [numberMessagesLast, setNumberMessagesLast] = useState(0);

  const [numberInterval, setNumberInterval] = useState(0);

  const [numberIntervalLast, setNumberIntervalLast] = useState(0);

  const [numberAudio, setNumberAudio] = useState(0);

  const [numberAudioLast, setNumberAudioLast] = useState(0);

  const [numberVideo, setNumberVideo] = useState(0);

  const [numberVideoLast, setNumberVideoLast] = useState(0);

  const [numberImg, setNumberImg] = useState(0);

  const [numberImgLast, setNumberImgLast] = useState(0);

  const [loading, setLoading] = useState(false);

  const [previewImg, setPreviewImg] = useState([]);

  const [previewAudios, setPreviewAudios] = useState([]);

  const [previewVideos, setPreviewVideos] = useState([]);

  const [arrayOption, setArrayOption] = useState([]);

  const [variables, setVariables] = useState([]);

  const [previewDocs, setPreviewDocs] = useState([]);
  const [numberDocLast, setNumberDocLast] = useState(0);
  const [numberDocs, setNumberDocs] = useState(0);

  const [labels, setLabels] = useState({
    title: i18n.t("flowBuilder.modals.singleBlock.addTitle"),
    btn: i18n.t("flowBuilder.modals.singleBlock.add"),
  });

  const { user } = useContext(AuthContext);

  const companyId = user.companyId;

  const handleElements = (newNameFiles) => {
    let elementsSequence = [];

    const newArrMessage = elementsSeq.filter((item) =>
      item.includes("message")
    );
    const newArrInterval = elementsSeq.filter((item) =>
      item.includes("interval")
    );
    const newArrImg = elementsSeq.filter((item) => item.includes("img"));
    const newArrAudio = elementsSeq.filter((item) => item.includes("audio"));
    const newArrVideo = elementsSeq.filter((item) => item.includes("video"));

    //Todas as mensagens
    for (let i = 0; i < numberMessages; i++) {
      const value = document
        .querySelector(`.${newArrMessage[i]}`)
        .querySelector(".MuiInputBase-input").value;
      if (!value) {
        toast.error(i18n.t("flowBuilder.modals.singleBlock.toastEmptyMessage"));
        setLoading(false);
        throw "";
      }
      elementsSequence.push({
        type: "message",
        value: value,
        number: newArrMessage[i],
      });
      console.log("text");
    }
    //Todos os intervalos
    for (let i = 0; i < numberInterval; i++) {
      const value = document
        .querySelector(`.${newArrInterval[i]}`)
        .querySelector(".MuiInputBase-input").value;
      if (parseInt(value) === 0 || parseInt(value) > 120) {
        toast.error(i18n.t("flowBuilder.modals.singleBlock.toastIntervalRange"));
        setLoading(false);
        throw "";
      }
      elementsSequence.push({
        type: "interval",
        value: value,
        number: newArrInterval[i],
      });
    }

    //Todas as imagens
    for (let i = 0; i < numberImg; i++) {
      const onlyImg =
        newNameFiles !== null &&
        newNameFiles.filter(
          (file) =>
            file.includes("png") ||
            file.includes("jpg") ||
            file.includes("jpeg")
        );
      const onlyImgNameOriginal = medias.filter(
        (file) =>
          file.name.includes("png") ||
          file.name.includes("jpg") ||
          file.name.includes("jpeg")
      );
      if (elementsSeqEdit.includes(newArrImg[i])) {
        const itemSelectedEdit = elementsEdit.filter(
          (item) => item.number === newArrImg[i]
        )[0];
        const captionEl = document.querySelector(`.captionImg${newArrImg[i].replace("img", "")} .MuiInputBase-input`);
        elementsSequence.push({
          type: "img",
          value: itemSelectedEdit.value,
          original: itemSelectedEdit.original,
          number: itemSelectedEdit.number,
          caption: captionEl ? captionEl.value : (itemSelectedEdit.caption || ""),
          teste: "image",
        });
      } else {
        let indexElem = 0;
        if (elementsSeqEdit.filter((item) => item.includes("img")).length > 0) {
          indexElem =
            elementsSeqEdit.filter((item) => item.includes("img")).length - i;
        } else {
          indexElem = i;
        }

        // console.log("IMAGE", indexElem, '-->>', onlyImgNameOriginal[indexElem]);

        const captionEl = document.querySelector(`.captionImg${newArrImg[i].replace("img", "")} .MuiInputBase-input`);
        elementsSequence.push({
          type: "img",
          value: onlyImg[indexElem],
          original: onlyImgNameOriginal[indexElem].name,
          number: newArrImg[i],
          caption: captionEl ? captionEl.value : "",
          teste: "image",
        });
      }
    }
    //Todos os audios
    for (let i = 0; i < numberAudio; i++) {
      const onlyAudio =
        newNameFiles !== null &&
        newNameFiles.filter(
          (file) =>
            file.includes("mp3") ||
            file.includes("ogg") ||
            file.includes("mpeg") ||
            file.includes("opus")
        );
      const onlyAudioNameOriginal = medias.filter(
        (file) =>
          file.name.includes("mp3") ||
          file.name.includes("ogg") ||
          file.name.includes("mpeg") ||
          file.name.includes("opus")
      );

      if (elementsSeqEdit.includes(newArrAudio[i])) {
        const itemSelectedEdit = elementsEdit.filter(
          (item) => item.number === newArrAudio[i]
        )[0];
        const captionEl = document.querySelector(`.captionAudio${newArrAudio[i].replace("audio", "")} .MuiInputBase-input`);
        elementsSequence.push({
          type: "audio",
          value: itemSelectedEdit.value,
          original: itemSelectedEdit.original,
          number: itemSelectedEdit.number,
          caption: captionEl ? captionEl.value : (itemSelectedEdit.caption || ""),
          record: document
            .querySelector(`.check${newArrAudio[i]}`)
            .querySelector(".PrivateSwitchBase-input").checked,
        });
      } else {
        let indexElem = 0;
        if (
          elementsSeqEdit.filter((item) => item.includes("audio")).length > 0
        ) {
          indexElem =
            elementsSeqEdit.filter((item) => item.includes("audio")).length - i;
        } else {
          indexElem = i;
        }
        const captionEl = document.querySelector(`.captionAudio${newArrAudio[i].replace("audio", "")} .MuiInputBase-input`);
        elementsSequence.push({
          type: "audio",
          value: onlyAudio[indexElem],
          original: onlyAudioNameOriginal[indexElem].name,
          number: newArrAudio[i],
          caption: captionEl ? captionEl.value : "",
          record: document
            .querySelector(`.check${newArrAudio[i]}`)
            .querySelector(".PrivateSwitchBase-input").checked,
        });
      }
    }
    //Todos os videos
    for (let i = 0; i < numberVideo; i++) {
      const onlyVideo =
        newNameFiles !== null &&
        newNameFiles.filter(
          (file) => file.includes("mp4") || file.includes("avi")
        );
      const onlyVideoNameOriginal = medias.filter(
        (file) => file.name.includes("mp4") || file.name.includes("avi")
      );
      if (elementsSeqEdit.includes(newArrVideo[i])) {
        const itemSelectedEdit = elementsEdit.filter(
          (item) => item.number === newArrVideo[i]
        )[0];
        const captionEl = document.querySelector(`.captionVideo${newArrVideo[i].replace("video", "")} .MuiInputBase-input`);
        elementsSequence.push({
          type: "video",
          value: itemSelectedEdit.value,
          original: itemSelectedEdit.original,
          number: itemSelectedEdit.number,
          caption: captionEl ? captionEl.value : (itemSelectedEdit.caption || ""),
        });
      } else {
        let indexElem = 0;
        if (
          elementsSeqEdit.filter((item) => item.includes("video")).length > 0
        ) {
          indexElem =
            elementsSeqEdit.filter((item) => item.includes("video")).length - i;
        } else {
          indexElem = i;
        }
        const captionEl = document.querySelector(`.captionVideo${newArrVideo[i].replace("video", "")} .MuiInputBase-input`);
        elementsSequence.push({
          type: "video",
          value: onlyVideo[indexElem],
          original: onlyVideoNameOriginal[indexElem].name,
          number: newArrVideo[i],
          caption: captionEl ? captionEl.value : "",
        });
      }
    }
    // Todos os documentos
    for (let i = 0; i < numberDocs; i++) {
      const onlyDocs =
        newNameFiles !== null &&
        newNameFiles.filter((file) => file.includes("pdf"));
      const onlyDocNameOriginal = medias.filter((file) =>
        file.name.includes("pdf")
      );

      // console.log("### elementsSeqEdit", elementsSeqEdit);

      if (elementsSeqEdit.includes(`document${i}`)) {
        const itemSelectedEdit = elementsEdit.filter(
          (item) => item.number === `document${i}`
        )[0];
        elementsSequence.push({
          type: "document",
          value: itemSelectedEdit?.value,
          original: itemSelectedEdit?.original,
          number: itemSelectedEdit?.number,
        });
      } else {
        let indexElem = 0;
        if (
          elementsSeqEdit.filter((item) => item.includes("document")).length > 0
        ) {
          indexElem =
            elementsSeqEdit.filter((item) => item.includes("document")).length -
            i;
        } else {
          indexElem = i;
        }

        // console.log("onlyDocs", onlyDocs);
        // console.log("onlyDocNameOriginal", onlyDocNameOriginal);
        // console.log("DOCUMENT", indexElem, '-->>', onlyDocNameOriginal[indexElem]);

        elementsSequence.push({
          type: "document",
          value: onlyDocs[indexElem],
          original: onlyDocNameOriginal[indexElem].name,
          number: `document${i}`,
        });
      }
    }

    console.log("elementsSequence", elementsSequence);

    return elementsSequence;
  };

  const deleteElementsTypeOne = (id, type) => {
    if (type === "message") {
      setNumberMessages((old) => old - 1);
      setElementsSeq((old) => old.filter((item) => item !== `message${id}`));
      setElementsSeqEdit((old) =>
        old.filter((item) => item !== `message${id}`)
      );
      document.querySelector(`.stackMessage${id}`).remove();
    }
    if (type === "interval") {
      setNumberInterval((old) => old - 1);
      setElementsSeq((old) => old.filter((item) => item !== `interval${id}`));
      setElementsSeqEdit((old) =>
        old.filter((item) => item !== `interval${id}`)
      );
      document.querySelector(`.stackInterval${id}`).remove();
    }
    if (type === "img") {
      setNumberImg((old) => old - 1);
      setPreviewImg((old) => {
        setMedias((oldMedia) => {
          try {
            return oldMedia.filter(
              (mediaItem) =>
                mediaItem.name !==
                old.filter((item) => item.number === id)[0].name
            );
          } catch (e) {
            return oldMedia;
          }
        });
        return old.filter((item) => item.number !== id);
      });
      setElementsSeq((old) => old.filter((item) => item !== `img${id}`));
      setElementsSeqEdit((old) => old.filter((item) => item !== `img${id}`));
      document.querySelector(`.stackImg${id}`).remove();
    }
    if (type === "audio") {
      setNumberAudio((old) => old - 1);
      setPreviewAudios((old) => {
        setMedias((oldMedia) => {
          try {
            return oldMedia.filter(
              (mediaItem) =>
                mediaItem.name !==
                old.filter((item) => item.number === id)[0].name
            );
          } catch (e) {
            return oldMedia;
          }
        });
        return old.filter((item) => item.number !== id);
      });
      setElementsSeq((old) => old.filter((item) => item !== `audio${id}`));
      setElementsSeqEdit((old) => old.filter((item) => item !== `audio${id}`));
      document.querySelector(`.stackAudio${id}`).remove();
    }
    if (type === "video") {
      setNumberVideo((old) => old - 1);
      setPreviewVideos((old) => {
        setMedias((oldMedia) => {
          try {
            return oldMedia.filter(
              (mediaItem) =>
                mediaItem.name !==
                old.filter((item) => item.number === id)[0].name
            );
          } catch (e) {
            return oldMedia;
          }
        });
        return old.filter((item) => item.number !== id);
      });
      setElementsSeq((old) => old.filter((item) => item !== `video${id}`));
      setElementsSeqEdit((old) => old.filter((item) => item !== `video${id}`));
      document.querySelector(`.stackVideo${id}`).remove();
    }
    if (type === "document") {
      setNumberDocs((old) => old - 1);
      setPreviewDocs((old) => {
        setMedias((oldMedia) => {
          try {
            return oldMedia.filter(
              (mediaItem) =>
                mediaItem.name !==
                old.filter((item) => item.number === id)[0].name
            );
          } catch (e) {
            return oldMedia;
          }
        });
        return old.filter((item) => item.number !== id);
      });
      setElementsSeq((old) => old.filter((item) => item !== `document${id}`));
      setElementsSeqEdit((old) =>
        old.filter((item) => item !== `document${id}`)
      );
      document.querySelector(`.stackDocument${id}`).remove();
    }
  };

  const moveElementDown = (id) => {
    setElementsSeq((old) => {
      const array = old;
      const index = array.indexOf(id);
      moveItemParaFrente(index);
      console.log("id", id);
      if (index !== -1 && index < array.length - 1) {
        // Verifica se o elemento foi encontrado no array e não está na última posição
        const novoArray = [...array]; // Cria uma cópia do array original
        const elementoMovido = novoArray.splice(index, 1)[0];
        novoArray.splice(index + 1, 0, elementoMovido);
        return novoArray;
      }
      return array;
    });
  };

  const moveElementUp = (id) => {
    setElementsSeq((old) => {
      const array = old;
      const index = array.indexOf(id);
      moveItemParaTras(index);

      if (index !== -1 && index > 0) {
        // Verifica se o elemento foi encontrado no array e não está na primeira posição
        const novoArray = [...array]; // Cria uma cópia do array original
        const elementoMovido = novoArray.splice(index, 1)[0];
        novoArray.splice(index - 1, 0, elementoMovido);
        return novoArray;
      }
      return array;
    });
  };

  function moveItemParaFrente(posicao) {
    setElements((old) => {
      const array = old;

      if (posicao >= 0 && posicao < array.length - 1) {
        const novoArray = [...array]; // Cria uma cópia do array original
        const elementoMovido = novoArray.splice(posicao, 1)[0];
        novoArray.splice(posicao + 1, 0, elementoMovido);
        return novoArray;
      }

      return array; // Retorna o array original se a movimentação não for possível
    });
  }

  function moveItemParaTras(posicao) {
    setElements((old) => {
      const array = old;
      if (posicao > 0 && posicao < array.length) {
        const novoArray = [...array]; // Cria uma cópia do array original
        const elementoMovido = novoArray.splice(posicao, 1)[0];
        novoArray.splice(posicao - 1, 0, elementoMovido);
        return novoArray;
      }

      return array; // Retorna o array original se a movimentação não for possível
    });
  }

  const handleChangeMediasImg = (e, number) => {
    if (!e.target.files) {
      return;
    }

    if (e.target.files[0].size > 2000000) {
      toast.error(i18n.t("flowBuilder.modals.singleBlock.toastImageTooBig"));
      return;
    }
    const imgBlob = URL.createObjectURL(e.target.files[0]);
    // console.log("imgBlob", imgBlob);
    setPreviewImg((old) => [
      ...old,
      {
        number: number,
        url: imgBlob,
        name: e.target.files[0].name,
      },
    ]);
    const selectedMedias = Array.from(e.target.files);
    setMedias((old) => [...old, selectedMedias[0]]);

    document.querySelector(`.img${number}`).src = imgBlob;
    document.querySelector(`.btnImg${number}`).remove();
  };

  const handleChangeAudios = (e, number) => {
    if (!e.target.files) {
      return;
    }

    if (e.target.files[0].size > 5000000) {
      toast.error(i18n.t("flowBuilder.modals.singleBlock.toastAudioTooBig"));
      return;
    }

    const audioBlob = URL.createObjectURL(e.target.files[0]);
    setPreviewAudios((old) => [
      ...old,
      {
        number: number,
        url: audioBlob,
        name: e.target.files[0].name,
      },
    ]);

    const selectedMedias = Array.from(e.target.files);
    setMedias((old) => [...old, selectedMedias[0]]);

    document.querySelector(
      `.audio${number}`
    ).innerHTML = `<audio controls="controls">
    <source src="${audioBlob}" type="audio/mp3" />
    ${i18n.t("flowBuilder.nodeLabels.noHtml5Support")}
  </audio>`;
    document.querySelector(`.btnAudio${number}`).remove();
  };

  const handleChangeVideos = (e, number) => {
    if (!e.target.files) {
      return;
    }

    if (e.target.files[0].size > 20000000) {
      toast.error(i18n.t("flowBuilder.modals.singleBlock.toastVideoTooBig"));
      return;
    }
    const videoBlob = URL.createObjectURL(e.target.files[0]);
    setPreviewVideos((old) => [
      ...old,
      {
        number: number,
        url: videoBlob,
        name: e.target.files[0].name,
      },
    ]);

    var divConteudo = document.createElement("div");

    const selectedMedias = Array.from(e.target.files);
    setMedias((old) => [...old, selectedMedias[0]]);

    divConteudo.innerHTML = `<video controls="controls" style="width: 200px;">
    <source src="${videoBlob}" type="video/mp4" />
    ${i18n.t("flowBuilder.nodeLabels.noHtml5Support")}
  </video>`;

    document.querySelector(`.video${number}`).appendChild(divConteudo);
    document.querySelector(`.btnVideo${number}`).remove();
  };

  const handleAddVariableToField = (value, className) => {
    const input = document.querySelector(`.${className} .MuiInputBase-input`);
    if (input) {
      const start = input.selectionStart || input.value.length;
      const end = input.selectionEnd || input.value.length;
      const newValue = input.value.substring(0, start) + value + input.value.substring(end);
      const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, 'value')?.set
        || Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')?.set;
      if (nativeInputValueSetter) {
        nativeInputValueSetter.call(input, newValue);
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
      setTimeout(() => {
        input.focus();
        input.setSelectionRange(start + value.length, start + value.length);
      }, 50);
    }
  };

  const imgLayout = (number, valueDefault = "", captionDefault = "") => {
    return (
      <Stack
        sx={{
          border: "1px solid #9a00ed",
          borderRadius: "7px",
          padding: "6px",
          position: "relative",
        }}
        className={`stackImg${number}`}
        key={`stackImg${number}`}
      >
        <Stack sx={{ position: "absolute", right: 6 }}>
          <Delete onClick={() => deleteElementsTypeOne(number, "img")} />
        </Stack>
        <Typography textAlign={"center"}>{i18n.t("flowBuilder.nodeLabels.image")}</Typography>
        <Stack direction={"row"} justifyContent={"center"}>
          <img
            src={
              valueDefault.length > 0
                ? `${process.env.REACT_APP_BACKEND_URL}/public/company${companyId}/flow/${valueDefault}`
                : ""
            }
            className={`img${number}`}
            style={{ width: "200px" }}
          />
        </Stack>
        {valueDefault.length === 0 && (
          <Button
            variant="contained"
            component="label"
            className={`btnImg${number}`}
          >
            {i18n.t("flowBuilder.modals.image.uploadButton")}
            <input
              type="file"
              accept="image/png, image/jpg, image/jpeg"
              hidden
              onChange={(e) => handleChangeMediasImg(e, number)}
            />
          </Button>
        )}
        <MessageVariablesPicker
          onClick={(val) => handleAddVariableToField(val, `captionImg${number}`)}
          disabled={false}
        />
        <TextField
          label={i18n.t("flowBuilder.modals.image.captionLabel")}
          multiline
          minRows={1}
          maxRows={3}
          defaultValue={captionDefault}
          variant="outlined"
          size="small"
          className={`captionImg${number}`}
          style={{ marginTop: 4 }}
        />
      </Stack>
    );
  };

  const audioLayout = (number, valueDefault = "", valueRecordDefault = "", captionDefault = "") => {
    return (
      <Stack
        sx={{
          border: "1px solid #9a00ed",
          borderRadius: "7px",
          padding: "6px",
          position: "relative",
        }}
        className={`stackAudio${number}`}
        key={`stackAudio${number}`}
      >
        <Stack
          sx={{ position: "absolute", right: 6 }}
          direction={"row"}
          gap={1}
        >
          <Delete
            sx={{ cursor: "pointer" }}
            onClick={() => deleteElementsTypeOne(number, "audio")}
          />
        </Stack>
        <Typography textAlign={"center"}>{i18n.t("flowBuilder.nodeLabels.audio")}</Typography>
        <div
          className={`audio${number}`}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          {valueDefault.length > 0 && (
            <audio controls="controls">
              <source
                src={`${process.env.REACT_APP_BACKEND_URL}/public/company${companyId}/flow/${valueDefault}`}
                type="audio/mp3"
              />
              {i18n.t("flowBuilder.nodeLabels.noHtml5Support")}
            </audio>
          )}
        </div>
        {valueDefault.length === 0 && (
          <Button
            variant="contained"
            component="label"
            className={`btnAudio${number}`}
          >
            {i18n.t("flowBuilder.modals.audio.uploadButton")}
            <input
              type="file"
              accept="audio/ogg, audio/mp3, audio/opus"
              hidden
              onChange={(e) => handleChangeAudios(e, number)}
            />
          </Button>
        )}
        <Stack direction={"row"} justifyContent={"center"}>
          <Checkbox
            className={`checkaudio${number}`}
            defaultChecked={valueRecordDefault === "ok" ? false : true}
          />
          <Stack justifyContent={"center"}>
            <Typography>{i18n.t("flowBuilder.modals.audio.sendAsRecorded")}</Typography>
          </Stack>
        </Stack>
        <MessageVariablesPicker
          onClick={(val) => handleAddVariableToField(val, `captionAudio${number}`)}
          disabled={false}
        />
        <TextField
          label={i18n.t("flowBuilder.modals.image.captionLabel")}
          multiline
          minRows={1}
          maxRows={3}
          defaultValue={captionDefault}
          variant="outlined"
          size="small"
          className={`captionAudio${number}`}
          style={{ marginTop: 4 }}
        />
      </Stack>
    );
  };

  const videoLayout = (number, valueDefault = "", captionDefault = "") => {
    return (
      <Stack
        sx={{
          border: "1px solid #9a00ed",
          borderRadius: "7px",
          padding: "6px",
          position: "relative",
        }}
        className={`stackVideo${number}`}
        key={`stackVideo${number}`}
      >
        <Stack sx={{ position: "absolute", right: 6 }}>
          <Delete onClick={() => deleteElementsTypeOne(number, "video")} />
        </Stack>
        <Typography textAlign={"center"}>{i18n.t("flowBuilder.nodeLabels.video")}</Typography>
        <div
          className={`video${number}`}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          {valueDefault.length > 0 && (
            <video controls="controls" style={{ width: "200px" }}>
              <source
                src={`${process.env.REACT_APP_BACKEND_URL}/public/company${companyId}/flow/${valueDefault}`}
                type="video/mp4"
              />
              {i18n.t("flowBuilder.nodeLabels.noHtml5Support")}
            </video>
          )}
        </div>
        {valueDefault.length === 0 && (
          <Button
            variant="contained"
            component="label"
            className={`btnVideo${number}`}
          >
            {i18n.t("flowBuilder.modals.video.uploadButton")}
            <input
              type="file"
              accept="video/mp4"
              hidden
              onChange={(e) => handleChangeVideos(e, number)}
            />
          </Button>
        )}
        <MessageVariablesPicker
          onClick={(val) => handleAddVariableToField(val, `captionVideo${number}`)}
          disabled={false}
        />
        <TextField
          label={i18n.t("flowBuilder.modals.image.captionLabel")}
          multiline
          minRows={1}
          maxRows={3}
          defaultValue={captionDefault}
          variant="outlined"
          size="small"
          className={`captionVideo${number}`}
          style={{ marginTop: 4 }}
        />
      </Stack>
    );
  };

  const messageLayout = (number, valueDefault = "") => {
    return (
      <Stack
        sx={{
          border: "1px solid #9a00ed",
          borderRadius: "7px",
          padding: "6px",
          position: "relative",
        }}
        className={`stackMessage${number}`}
        key={`stackMessage${number}`}
      >
        <Stack sx={{ position: "absolute", right: 6 }}>
          <Delete onClick={() => deleteElementsTypeOne(number, "message")} />
        </Stack>
        <Typography textAlign={"center"}>{i18n.t("flowBuilder.nodes.text.name")}</Typography>
        <TextField
          label={i18n.t("flowBuilder.modals.text.messageLabel")}
          defaultValue={valueDefault}
          multiline
          rows={7}
          className={`message${number}`}
          name="text"
          variant="outlined"
          margin="dense"
          style={{ width: "100%" }}
        />
      </Stack>
    );
  };

  const intervalLayout = (number, valueDefault = 0) => {
    return (
      <Stack
        sx={{
          border: "1px solid #9a00ed",
          borderRadius: "7px",
          padding: "6px",
          position: "relative",
        }}
        className={`stackInterval${number}`}
        key={`stackInterval${number}`}
      >
        <Stack sx={{ position: "absolute", right: 6 }}>
          <Delete onClick={() => deleteElementsTypeOne(number, "interval")} />
        </Stack>
        <Typography textAlign={"center"}>{i18n.t("flowBuilder.nodes.interval.name")}</Typography>
        <TextField
          label={i18n.t("flowBuilder.modals.interval.secondsLabel")}
          className={`interval${number}`}
          defaultValue={valueDefault}
          type="number"
          InputProps={{ inputProps: { min: 0, max: 120 } }}
          variant="outlined"
          margin="dense"
          style={{ width: "100%" }}
        />
      </Stack>
    );
  };

  const documentLayout = (number, valueDefault = "") => {
    return (
      <Stack
        sx={{
          border: "1px solid #9a00ed",
          borderRadius: "7px",
          padding: "6px",
          position: "relative",
        }}
        className={`stackDocument${number}`}
        key={`stackDocument${number}`}
      >
        <Stack sx={{ position: "absolute", right: 6 }}>
          <Delete onClick={() => deleteElementsTypeOne(number, "document")} />
        </Stack>
        <Typography textAlign={"center"}>{i18n.t("flowBuilder.modals.singleBlock.documentLabel")}</Typography>
        <div
          className={`document${number}`}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          {valueDefault.length > 0 ? (
            <embed
              src={`${process.env.REACT_APP_BACKEND_URL}/public/company${companyId}/flow/${valueDefault}`}
              type="application/pdf"
              width="200px"
              height="200px"
            />
          ) : null}
        </div>
        {valueDefault.length === 0 && (
          <Button
            variant="contained"
            component="label"
            className={`btnDocument${number}`}
          >
            {i18n.t("flowBuilder.modals.singleBlock.uploadDocument")}
            <input
              type="file"
              accept=".doc,.docx,.pdf"
              hidden
              onChange={(e) => handleChangeDocuments(e, number)}
            />
          </Button>
        )}
      </Stack>
    );
  };

  const handleChangeDocuments = (e, number) => {
    if (!e.target.files) {
      return;
    }

    if (e.target.files[0].size > 10000000) {
      toast.error(i18n.t("flowBuilder.modals.singleBlock.toastDocumentTooBig"));
      return;
    }

    const file = e.target.files[0];
    const documentBlob = URL.createObjectURL(file);

    // Verifica se o arquivo é PDF
    const isPDF = file.type === "application/pdf";

    setPreviewDocs((old) => [
      ...old,
      {
        number: number,
        url: documentBlob,
        name: file.name,
      },
    ]);

    const selectedMedias = Array.from(e.target.files);
    setMedias((old) => [...old, selectedMedias[0]]);

    if (isPDF) {
      document.querySelector(`.document${number}`).innerHTML = `
        <embed src="${documentBlob}" type="application/pdf" width="200px" height="200px" />
      `;
    } else {
      document.querySelector(`.document${number}`).innerHTML = `
        <a href="${documentBlob}" target="_blank" rel="noopener noreferrer">${i18n.t("flowBuilder.modals.singleBlock.viewDocument")}</a>
      `;
    }
    document.querySelector(`.btnDocument${number}`).remove();
  };

  // Variáveis do sistema disponíveis para uso nas mensagens do fluxo
  const systemVariables = [
    "firstName",
    "name",
    "userName",
    "ms",
    "protocol",
    "date",
    "hour",
    "ticket_id",
    "queue",
    "connection",
    "phoneNumber",
    "email",
    "kanban",
  ];

  useEffect(() => {
    const localVariables = localStorage.getItem("variables");
    const flowVars = localVariables ? JSON.parse(localVariables) : [];
    // Mescla variáveis do sistema + variáveis dinâmicas do fluxo (sem duplicatas)
    const allVars = [...systemVariables, ...flowVars.filter(v => !systemVariables.includes(v))];
    setVariables(allVars);

    if (open === "edit") {
      setLabels({
        title: i18n.t("flowBuilder.modals.singleBlock.editTitle"),
        btn: i18n.t("flowBuilder.modals.singleBlock.save"),
      });

      setElementsSeq(data.data.seq);

      setElementsSeqEdit(data.data.seq);
      setElementsEdit(data.data.elements);
      if (data) {
        const elementsEditLoc = data.data.elements;
        const sequence = data.data.seq;

        sequence.map((item) => {
          const itemNode = elementsEditLoc.filter(
            (inode) => inode.number === item
          )[0];
          if (itemNode.type === "message") {
            const numberLoc = parseInt(item.replace("message", ""));
            setElements((elm) => [
              ...elm,
              messageLayout(numberLoc, itemNode.value),
            ]);
            setNumberMessages((old) => {
              const arsOnly = sequence.filter((item) =>
                item.includes("message")
              );
              const arrNumberMax = arsOnly.map((item) =>
                parseInt(item.replace("message", ""))
              );
              setNumberMessagesLast(Math.max.apply(null, arrNumberMax) + 1);
              return old + 1;
            });
          }
          if (itemNode.type === "interval") {
            const numberLoc = parseInt(item.replace("interval", ""));
            setElements((elm) => [
              ...elm,
              intervalLayout(numberLoc, itemNode.value),
            ]);
            setNumberInterval((old) => {
              const arsOnly = sequence.filter((item) =>
                item.includes("interval")
              );
              const arrNumberMax = arsOnly.map((item) =>
                parseInt(item.replace("interval", ""))
              );
              setNumberIntervalLast(Math.max.apply(null, arrNumberMax) + 1);
              return old + 1;
            });
          }
          if (itemNode.type === "audio") {
            const numberLoc = parseInt(item.replace("audio", ""));
            setElements((elm) => [
              ...elm,
              audioLayout(
                numberLoc,
                itemNode.value,
                itemNode.record ? "" : "ok",
                itemNode.caption || ""
              ),
            ]);
            setNumberAudio((old) => {
              const arsOnly = sequence.filter((item) => item.includes("audio"));
              const arrNumberMax = arsOnly.map((item) =>
                parseInt(item.replace("audio", ""))
              );
              setNumberAudioLast(Math.max.apply(null, arrNumberMax) + 1);
              return old + 1;
            });
          }
          if (itemNode.type === "img") {
            const numberLoc = parseInt(item.replace("img", ""));
            setElements((elm) => [
              ...elm,
              imgLayout(numberLoc, itemNode.value, itemNode.caption || ""),
            ]);
            setNumberImg((old) => {
              const arsOnly = sequence.filter((item) => item.includes("img"));
              const arrNumberMax = arsOnly.map((item) =>
                parseInt(item.replace("img", ""))
              );
              setNumberImgLast(Math.max.apply(null, arrNumberMax) + 1);
              return old + 1;
            });
          }
          if (itemNode.type === "video") {
            const numberLoc = parseInt(item.replace("video", ""));
            setElements((elm) => [
              ...elm,
              videoLayout(numberLoc, itemNode.value, itemNode.caption || ""),
            ]);
            setNumberVideo((old) => {
              const arsOnly = sequence.filter((item) => item.includes("video"));
              const arrNumberMax = arsOnly.map((item) =>
                parseInt(item.replace("video", ""))
              );
              setNumberVideoLast(Math.max.apply(null, arrNumberMax) + 1);
              return old + 1;
            });
          }
          if (itemNode.type === "document") {
            const numberLoc = parseInt(item.replace("document", ""));
            setElements((elm) => [
              ...elm,
              documentLayout(numberLoc, itemNode.value),
            ]);
            setNumberDocs((old) => {
              const arsOnly = sequence.filter((item) =>
                item.includes("document")
              );
              const arrNumberMax = arsOnly.map((item) =>
                parseInt(item.replace("document", ""))
              );
              setNumberDocLast(Math.max.apply(null, arrNumberMax) + 1);
              return old + 1;
            });
          }
        });
      }
      setActiveModal(true);
    }
    if (open === "create") {
      setLabels({
        title: i18n.t("flowBuilder.modals.singleBlock.addTitle"),
        btn: i18n.t("flowBuilder.modals.singleBlock.add"),
      });
      setTextDig();
      setArrayOption([]);
      setActiveModal(true);
    }
  }, [open]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleClose = async () => {
    close(null);
    setActiveModal(false);
    setTimeout(() => {
      setMedias([]);
      setPreviewImg([]);
      setPreviewAudios([]);
      setPreviewVideos([]);
      setArrayOption([]);
      setElements([]);
      setElementsSeq([]);
      setElementsEdit([]);
      setElementsSeqEdit([]);
      setNumberMessages(0);
      setNumberMessagesLast(0);
      setNumberInterval(0);
      setNumberIntervalLast(0);
      setNumberAudio(0);
      setNumberAudioLast(0);
      setNumberVideo(0);
      setNumberVideoLast(0);
      setNumberImg(0);
      setNumberImgLast(0);
    }, 500);
  };

  const verifyButtonsUpload = () => {
    const newArrImg = elementsSeq.filter((item) => item.includes("img"));
    const newArrAudio = elementsSeq.filter((item) => item.includes("audio"));
    const newArrVideo = elementsSeq.filter((item) => item.includes("video"));
    const newArrDocs = elementsSeq.filter((item) => item.includes("document"));

    for (let i = 0; i < numberImg; i++) {
      const imgVerify = document.querySelector(
        `.btn${capitalize(newArrImg[i])}`
      );
      if (imgVerify) {
        return true;
      }
    }
    for (let i = 0; i < numberAudio; i++) {
      const audioVerify = document.querySelector(
        `.btn${capitalize(newArrAudio[i])}`
      );
      if (audioVerify) {
        return true;
      }
    }
    for (let i = 0; i < numberVideo; i++) {
      const videoVerify = document.querySelector(
        `.btn${capitalize(newArrVideo[i])}`
      );
      if (videoVerify) {
        return true;
      }
    }
    for (let i = 0; i < numberDocs; i++) {
      const docVerify = document.querySelector(`.btnDocument${i}`);
      if (docVerify) {
        return true;
      }
    }
  };

  const handleSaveNode = async () => {
    if (open === "edit") {
      setLoading(true);
      const formData = new FormData();

      medias.forEach(async (media, idx) => {
        const file = media;

        if (!file) {
          return;
        }

        if (media?.type.split("/")[0] === "image") {
          formData.append("typeArch", "flow");
          formData.append("medias", file);
          formData.append("body", file.name);
        } else if (media?.type.split("/")[0] === "audio") {
          formData.append("typeArch", "flow");
          formData.append("medias", file);
          formData.append("body", file.name);
        } else if (media?.type.split("/")[0] === "video") {
          formData.append("typeArch", "flow");
          formData.append("medias", file);
          formData.append("body", file.name);
        } else if (
          media?.type.split("/")[0] === "application" ||
          media?.type.split("/")[1] === "document" ||
          media?.type.split("/")[1] === "pdf"
        ) {
          formData.append("typeArch", "flow");
          formData.append("medias", file);
          formData.append("body", file.name);
        } else {
          formData.append("typeArch", "flow");
          formData.append("medias", file);
          formData.append("body", file.name);
        }
      });

      setTimeout(async () => {
        if (
          (numberAudio === 0 &&
            numberVideo === 0 &&
            numberImg === 0 &&
            numberDocs === 0) ||
          medias.length === 0
        ) {
          try {
            const mountData = {
              seq: elementsSeq,
              elements: handleElements(null),
            };
            onUpdate({
              ...data,
              data: mountData,
            });
            toast.success(i18n.t("flowBuilder.modals.singleBlock.toastContentAdded"));
            handleClose();
            setLoading(false);

            return;
          } catch (e) {
            console.log("error1", e);
            setLoading(false);
            handleClose();
          }
          return;
        }
        const verify = verifyButtonsUpload();
        if (verify) {
          setLoading(false);
          return toast.error(i18n.t("flowBuilder.modals.singleBlock.toastDeleteEmptyCards"));
        }

        await api
          .post("/flowbuilder/content", formData)
          .then(async (res) => {
            const mountData = {
              seq: elementsSeq,
              elements: handleElements(res.data),
            };
            onUpdate({
              ...data,
              data: mountData,
            });
            toast.success(i18n.t("flowBuilder.modals.singleBlock.toastContentAdded"));
            handleClose();
            setLoading(false);
          })
          .catch((error) => {
            console.log("error2", error);
            handleClose();
            setLoading(false);
          });
      }, 1500);
    } else if (open === "create") {
      setLoading(true);
      const formData = new FormData();

      medias.forEach(async (media, idx) => {
        const file = media;

        if (!file) {
          return;
        }

        if (media?.type.split("/")[0] === "image") {
          formData.append("typeArch", "flow");
          formData.append("medias", media);
          formData.append("body", media.name);
        } else if (media?.type.split("/")[0] === "audio") {
          formData.append("typeArch", "flow");
          formData.append("medias", media);
          formData.append("body", media.name);
        } else if (media?.type.split("/")[0] === "video") {
          formData.append("typeArch", "flow");
          formData.append("medias", media);
          formData.append("body", media.name);
        } else if (
          media?.type.split("/")[0] === "application" ||
          media?.type.split("/")[1] === "document" ||
          media?.type.split("/")[1] === "pdf"
        ) {
          formData.append("typeArch", "flow");
          formData.append("medias", media);
          formData.append("body", media.name);
        } else {
          formData.append("typeArch", "flow");
          formData.append("medias", media);
          formData.append("body", media.name);
        }
      });

      setTimeout(async () => {
        if (
          numberAudio === 0 &&
          numberVideo === 0 &&
          numberImg === 0 &&
          numberDocs === 0
        ) {
          try {
            const mountData = {
              seq: elementsSeq,
              elements: handleElements(null),
            };
            onSave({
              ...mountData,
            });
            toast.success(i18n.t("flowBuilder.modals.singleBlock.toastContentAdded"));
            handleClose();
            setLoading(false);

            return;
          } catch (e) {
            console.log("error3", e);
            setLoading(false);
            handleClose();
          }
        }
        const verify = verifyButtonsUpload();
        if (verify) {
          setLoading(false);
          return toast.error(i18n.t("flowBuilder.modals.singleBlock.toastDeleteEmptyCards"));
        }
        await api
          .post("/flowbuilder/content", formData)
          .then((res) => {
            const mountData = {
              seq: elementsSeq,
              elements: handleElements(res.data),
            };
            onSave({
              ...mountData,
            });
            toast.success(i18n.t("flowBuilder.modals.singleBlock.toastContentAdded"));
            handleClose();
            setLoading(false);
          })
          .catch((error) => {
            console.log("error4", error);
            setLoading(false);
            handleClose();
          });
      }, 1500);
    }
  };

  const scrollToBottom = (className) => {
    const element = document.querySelector(className);
    element.scrollTop = element.scrollHeight;
  };

  const variableLabels = i18n.t("flowBuilder.modals.singleBlock.variableLabels", { returnObjects: true });

  const variableFormatter = (item) => {
    return "{{" + item + "}}";
  };

  const getVariableLabel = (item) => {
    return variableLabels[item] || item;
  };

  const insertVariableIntoLastMessage = (variable) => {
    // Find all message textareas in the modal
    const textareas = document.querySelectorAll('[class*="message"] textarea, [class*="message"] input');
    if (textareas.length === 0) return;
    const textarea = textareas[textareas.length - 1];
    const start = textarea.selectionStart || textarea.value.length;
    const end = textarea.selectionEnd || textarea.value.length;
    const newValue = textarea.value.substring(0, start) + variable + textarea.value.substring(end);
    // Use native setter to trigger React's onChange
    const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, 'value')?.set 
      || Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')?.set;
    if (nativeInputValueSetter) {
      nativeInputValueSetter.call(textarea, newValue);
      textarea.dispatchEvent(new Event('input', { bubbles: true }));
      textarea.dispatchEvent(new Event('change', { bubbles: true }));
    }
    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(start + variable.length, start + variable.length);
    }, 50);
  };

  return (
    <div>
      <Dialog open={activeModal} fullWidth="lg" scroll="paper">
        {!loading && (
          <DialogTitle id="form-dialog-title">
            {labels.title}
          </DialogTitle>
        )}
        <Stack>
          <Stack
            className="body-card"
            style={{
              gap: "8px",
              padding: "16px",
              overflow: "auto",
              height: "70vh",
              scrollBehavior: "smooth",
              display: loading && "none",
            }}
          >
            {elements.map((item) => (
              <>{item}</>
            ))}
            <Stack direction={"row"} gap={1}>
              {/* Texto */}
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setElements((old) => [
                    ...old,
                    messageLayout(numberMessagesLast),
                  ]);
                  setNumberMessages((old) => {
                    setElementsSeq((oldEleme) => [
                      ...oldEleme,
                      `message${numberMessagesLast}`,
                    ]);
                    return old + 1;
                  });
                  setNumberMessagesLast((old) => old + 1);
                  setTimeout(() => {
                    scrollToBottom(".body-card");
                  }, 100);
                }}
              >
                <Message
                  sx={{
                    width: "16px",
                    height: "16px",
                    marginRight: "4px",
                  }}
                />
                {i18n.t("flowBuilder.nodes.text.name")}
              </Button>
              {/* Intervalo */}
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setElements((old) => [
                    ...old,
                    intervalLayout(numberIntervalLast),
                  ]);
                  setNumberInterval((old) => {
                    setElementsSeq((oldEleme) => [
                      ...oldEleme,
                      `interval${numberIntervalLast}`,
                    ]);
                    return old + 1;
                  });
                  setNumberIntervalLast((old) => old + 1);
                  setTimeout(() => {
                    scrollToBottom(".body-card");
                  }, 100);
                }}
              >
                <AccessTime
                  sx={{
                    width: "16px",
                    height: "16px",
                    marginRight: "4px",
                  }}
                />
                {i18n.t("flowBuilder.nodes.interval.name")}
              </Button>
              {/* Imagem */}
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setElements((old) => [...old, imgLayout(numberImgLast)]);
                  setNumberImg((old) => {
                    setElementsSeq((oldEleme) => [
                      ...oldEleme,
                      `img${numberImgLast}`,
                    ]);
                    return old + 1;
                  });
                  setNumberImgLast((old) => old + 1);
                  setTimeout(() => {
                    scrollToBottom(".body-card");
                  }, 100);
                }}
              >
                <Image
                  sx={{
                    width: "16px",
                    height: "16px",
                    marginRight: "4px",
                  }}
                />
                {i18n.t("flowBuilder.nodeLabels.image")}
              </Button>
              {/* Audio */}
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setElements((old) => [...old, audioLayout(numberAudioLast)]);
                  setNumberAudio((old) => {
                    setElementsSeq((oldEleme) => [
                      ...oldEleme,
                      `audio${numberAudioLast}`,
                    ]);
                    return old + 1;
                  });
                  setNumberAudioLast((old) => old + 1);
                  setTimeout(() => {
                    scrollToBottom(".body-card");
                  }, 100);
                }}
              >
                <MicNone
                  sx={{
                    width: "16px",
                    height: "16px",
                    marginRight: "4px",
                  }}
                />
                {i18n.t("flowBuilder.nodeLabels.audio")}
              </Button>
              {/* Video */}
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setElements((old) => [...old, videoLayout(numberVideoLast)]);
                  setNumberVideo((old) => {
                    setElementsSeq((oldEleme) => [
                      ...oldEleme,
                      `video${numberVideoLast}`,
                    ]);
                    return old + 1;
                  });
                  setNumberVideoLast((old) => old + 1);
                  setTimeout(() => {
                    scrollToBottom(".body-card");
                  }, 100);
                }}
              >
                <Videocam
                  sx={{
                    width: "16px",
                    height: "16px",
                    marginRight: "4px",
                  }}
                />
                {i18n.t("flowBuilder.nodeLabels.video")}
              </Button>
              {/* Documento */}
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setElements((old) => [...old, documentLayout(numberDocLast)]);
                  setNumberDocs((old) => {
                    setElementsSeq((oldEleme) => [
                      ...oldEleme,
                      `document${numberDocLast}`,
                    ]);
                    return old + 1;
                  });
                  setNumberDocLast((old) => old + 1);
                  setTimeout(() => {
                    scrollToBottom(".body-card");
                  }, 100);
                }}
              >
                <InsertDriveFile
                  sx={{
                    width: "16px",
                    height: "16px",
                    marginRight: "4px",
                  }}
                />
                {i18n.t("flowBuilder.modals.singleBlock.documentLabel")}
              </Button>
            </Stack>
            <Box style={{ width: "100%", marginTop: 8 }}>
              <fieldset style={{ 
                border: "1px solid rgba(0,0,0,0.23)", 
                borderRadius: 4, 
                padding: "8px 12px",
                margin: 0 
              }}>
                <legend style={{ 
                  fontSize: "0.75rem", 
                  color: "rgba(0,0,0,0.54)",
                  padding: "0 4px" 
                }}>
                  {i18n.t("flowBuilder.modals.singleBlock.availableVariables")}
                </legend>
                {variables && (
                  <Box display="flex" flexWrap="wrap" style={{ gap: 4 }}>
                    {variables.map((item) => (
                      <Chip
                        key={item}
                        label={getVariableLabel(item)}
                        size="small"
                        color="primary"
                        style={{ cursor: "pointer", fontWeight: 500 }}
                        onClick={() => {
                          insertVariableIntoLastMessage(variableFormatter(item));
                        }}
                      />
                    ))}
                  </Box>
                )}
              </fieldset>
            </Box>
          </Stack>

          <DialogActions>
            <Button
              onClick={handleClose}
              color="secondary"
              variant="outlined"
              style={{ display: loading && "none" }}
            >
              {i18n.t("contactModal.buttons.cancel")}
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              onClick={() => handleSaveNode()}
              style={{ display: loading && "none" }}
            >
              {`${labels.btn}`}
            </Button>
          </DialogActions>
        </Stack>
        {loading && (
          <Stack
            style={{
              gap: "8px",
              padding: "16px",
              height: "70vh",
              alignSelf: "center",
              justifyContent: "center",
            }}
          >
            <Stack>
              <Typography>
                {i18n.t("flowBuilder.modals.singleBlock.uploadingContent")}
              </Typography>
              <Stack style={{ alignSelf: "center", marginTop: "12px" }}>
                <CircularProgress />
              </Stack>
            </Stack>
          </Stack>
        )}
      </Dialog>
    </div>
  );
};

export default FlowBuilderSingleBlockModal;
